import React from "react";
import { WraperItem } from './styles';

export const GridItem = ({ children, ...props }) => {
    return <WraperItem {...props}>{children}</WraperItem>;
};
